Vue.component("profilestaticitem", {
    props: {
        forecast: {
            type: Boolean,
            default: false
        },
        isloaded: {
            type: Boolean,
            default: true,
        },
        dataformat: {
            type: String,
            default: 'percent'
        },
        hastable: {
            type: Boolean,
            default: false
        },
        haslegend: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '',
        },
        featured: {
            type: Array,
            default: ()=>[]
        },
        sortedData: {
            type: Array,
            default: []
        }
    },
});
